// @ts-nocheck
import { chain, SendDataToApi } from "@insite/client-framework/Store/Pages/Cart/Handlers/AddToCart";
import { addProductWithResult as addProductWithResultOverride } from "@store/Modules/client-framework/src/Services/CartService";
import { replaceInChain } from "@toolkit/Modules/client-framework/HandlerCreator";

replaceInChain(chain, SendDataToApi, async props => {
    const result = await addProductWithResultOverride(props.apiParameter); // Store Custom Code
    if (result.successful) {
        props.apiResult = result.result;
    } else {
        if (result.statusCode === 403) {
            const { isAuthenticated, rememberMe } = props.getState().context.session;
            (isAuthenticated || rememberMe) && window.location.reload();
            return false;
        }

        props.parameter.onError?.(result.errorMessage);
        return false;
    }
});
